import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReactNode } from "react";

export interface ModalConfig {
  title?: string;
  content: ReactNode;
  footerButtons?: Array<{
    label: string;
    variant?: string;
    onClick: () => void;
    disabled?: boolean;
  }>;
  size?: "sm" | "lg" | "xl";
  centered?: boolean;
  closeButton?: boolean;
  className?: string;
  backdrop?: boolean | "static";
}

interface ModalState {
  isOpen: boolean;
  configVersion: number; // increments every openModal — forces re-render reliably
}

// Store config outside Redux so React elements (JSX) are never processed by
// Immer or serialized by Redux DevTools — preserves $$typeof Symbol.
let _modalConfig: ModalConfig | null = null;
export const getModalConfig = (): ModalConfig | null => _modalConfig;

const initialState: ModalState = {
  isOpen: false,
  configVersion: 0,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<ModalConfig>) {
      _modalConfig = action.payload;
      state.isOpen = true;
      state.configVersion += 1;
    },
    closeModal(state) {
      _modalConfig = null;
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
